import { call, put } from "redux-saga/effects";
import { subscriptionConstants } from "../actions/constants/subscriptionConstants";
import { commonConstants } from "../actions/constants/commonConstants";
import { subscriptionService } from "../services/subscriptionService";
import { downloadBlobFile } from "../services/helper";

function* getSubscriptionPlan(action: any): any {
  try {
    const response = yield call(subscriptionService.getSubscriptionPlan, action.payload);
    
    if (response.success) {
      yield put({  type: subscriptionConstants.getSubscriptionPlanSuccess, payload: response.resultObject 
      });
    } else {
      yield put({  type: subscriptionConstants.getSubscriptionPlanFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getSubscriptionPlanFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to fetch subscription plan" });
  }
}

function* getSubscriptionSyncStatus(action: any): any {
  try {
    const response = yield call(subscriptionService.getSubscriptionSyncStatus, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getSubscriptionSyncStatusSuccess, payload: response.resultObject });
    } else {  
    yield put({ type: subscriptionConstants.getSubscriptionSyncStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getSubscriptionSyncStatusFailure, payload: error });
  } 
}

function* getAllPlans(): any {
  try {
    const response = yield call(subscriptionService.getAllPlans);
    
    if (response.success) {
      yield put({  type: subscriptionConstants.getAllPlansSuccess, payload: response.resultObject 
      });
    } else {
      yield put({  type: subscriptionConstants.getAllPlansFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getAllPlansFailure, payload: error });
  }
}

function* createSubscription(action: any): any {
  try {
    const response = yield call(subscriptionService.createSubscription, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.createSubscriptionSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || "Subscription created successfully" });
    } else {
      yield put({ type: subscriptionConstants.createSubscriptionFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.createSubscriptionFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to create subscription" });
  }
}

function* getSubscriptionStatus(action: any): any {
  try {
    const response = yield call(subscriptionService.getSubscriptionStatus, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getSubscriptionStatusSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getSubscriptionStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getSubscriptionStatusFailure, payload: error });
  }
}

function* getOrderStatus(action: any): any {
  try {
    const response = yield call(subscriptionService.getOrderStatus, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getOrderStatusSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getOrderStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getOrderStatusFailure, payload: error });
  }
}

function* syncPlans(): any {
  try {
    const response = yield call(subscriptionService.syncPlans);
    if (response.success) {
      yield put({ type: subscriptionConstants.syncPlansSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || "Plans synced successfully" });
    } else {
      yield put({ type: subscriptionConstants.syncPlansFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.syncPlansFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to sync plans" });
  }
}

function* getUserSubscriptionStatus(): any {
  try {
    const response = yield call(subscriptionService.getUserSubscriptionStatus);
    if (response.success) {
      yield put({ type: subscriptionConstants.getUserSubscriptionStatusSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getUserSubscriptionStatusFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getUserSubscriptionStatusFailure, payload: error });
  }
}

/* ----------------- Super Admin: Subscription Plan management ---------------- */

function* listAdminPlans(action: any): any {
  try {
    const response = yield call(subscriptionService.listAdminPlans, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.listAdminPlansSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.listAdminPlansFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.listAdminPlansFailure, payload: error });
  }
}

function* viewAdminPlan(action: any): any {
  try {
    const response = yield call(subscriptionService.viewAdminPlan, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.viewAdminPlanSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.viewAdminPlanFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.viewAdminPlanFailure, payload: error });
  }
}

function* saveAdminPlan(action: any): any {
  try {
    const { id, data } = action.payload || {};
    const response = id
      ? yield call(subscriptionService.updateAdminPlan, { id, data })
      : yield call(subscriptionService.createAdminPlan, data);

    if (response.success) {
      yield put({ type: subscriptionConstants.saveAdminPlanSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || "Plan saved successfully" });
    } else {
      yield put({ type: subscriptionConstants.saveAdminPlanFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.saveAdminPlanFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to save plan" });
  }
}

function* deleteAdminPlan(action: any): any {
  try {
    const response = yield call(subscriptionService.deleteAdminPlan, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.deleteAdminPlanSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || "Plan deleted successfully" });
    } else {
      yield put({ type: subscriptionConstants.deleteAdminPlanFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.deleteAdminPlanFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to delete plan" });
  }
}

function* getRoutes(): any {
  try {
    const response = yield call(subscriptionService.getRoutes);
    if (response.success) {
      yield put({ type: subscriptionConstants.getRoutesSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getRoutesFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getRoutesFailure, payload: error });
  }
}

function* getInvoice(action: any): any {
  try {
    const response = yield call(subscriptionService.getInvoice, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getInvoiceSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getInvoiceFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getInvoiceFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to fetch invoice" });
  }
}

function* getAllInvoices(action: any): any {
  try {
    const response = yield call(subscriptionService.getAllInvoices, action.payload);
    if (response.success) {
      yield put({ type: subscriptionConstants.getAllInvoicesSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getAllInvoicesFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getAllInvoicesFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to fetch invoices" });
  }
}

function* getInvoicePDF(action: any): any {
  try {
    const response = yield call(subscriptionService.getInvoicePDF, action.payload);
    downloadBlobFile(response, 'invoice', "pdf");
    if (response.success) {
      yield put({ type: subscriptionConstants.getInvoicePDFSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getInvoicePDFFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getInvoicePDFFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to fetch invoice PDF" });
  }
}

function* getOverallInvoices(action: any): any {
  try {
    const response = yield call(subscriptionService.getOverallInvoices, action.payload);
    
    downloadBlobFile(response, 'invoice', action.payload?.format || "pdf");
    if (response.success) {
      yield put({ type: subscriptionConstants.getOverallInvoicesSuccess, payload: response.resultObject });
    } else {
      yield put({ type: subscriptionConstants.getOverallInvoicesFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: subscriptionConstants.getOverallInvoicesFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.errorMessage || "Failed to fetch overall invoices" });
  }
}



export const subscriptionSaga = {
  getSubscriptionPlan,
  createSubscription,
  getSubscriptionStatus,
  getOrderStatus,
  syncPlans,
  getAllPlans,
  getUserSubscriptionStatus,
  listAdminPlans,
  viewAdminPlan,
  saveAdminPlan,
  deleteAdminPlan,
  getSubscriptionSyncStatus,
  getRoutes,
  getInvoice,
  getAllInvoices,
  getInvoicePDF,
  getOverallInvoices
};
